import React, { useState, useContext, useEffect } from 'react';
import { AppContext, AuthContext } from 'Context';
import { useNavigate } from 'react-router-dom';
import './UserM.css';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { removeDummy, clearAllDummys, saveDummy, clearUploadDetails, saveUploadInfo } from 'store/store';
import { CircularProgress as MuiCircularProgress, withStyles, IconButton, Dialog, DialogTitle, DialogContent } from '@material-ui/core';
import { baseUrl, firebaseCredentials, endpoints } from 'Api';
import { ReactComponent as HiddenIcon } from 'Assets/eye.slash.svg';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import EmailIcon from '@material-ui/icons/Email';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import GetAppIcon from '@material-ui/icons/GetApp';
import { ref, get, getDatabase, off, onValue, update } from 'firebase/database';
import { initializeApp } from 'firebase/app';
import axios from 'axios';
import { InfoModal } from '../private/dashboard/info-modal/index';

function ManagerList({ isLoading, fetchMangerData, getToken, hiddenIndices, setHiddenIndices, userListData, setUserListData, showAll, clickLoading, setModal, isOpenModal, onLastAccessedCountChange }) {
  const dispatch = useDispatch();
  const { handleClick, setIamUploading, firebaseDatabase, setEncounterLoading, autoSignIn, setbigUserData, isTokenChange, iamUploading, getSubscription, setmessaged, setmangerFunctionData, setUploadContainer, setAppSnackbar, draftOfUpload, setActiveUploads, setUploadQueue, setOpen } = useContext(AppContext);
  const navigate = useNavigate();
  const tokens = getToken();
  const [isOpenInfoModal, setInfoModal] = useState(false);
  const [isOpenAllUsersModal, setIsOpenAllUsersModal] = useState(false);
  const [userObject, setUserObject] = useState();
  const [userIamChanging, setuserIamChanging] = useState(false);
  const [visibleEye, setVisibleEye] = useState(Array(userListData?.data?.length).fill(false));
  const [isInviting, setIsInviting] = useState(false);
  const [lastAccessedUsers, setLastAccessedUsers] = useState([]);
  const [isLoadingLastAccessed, setIsLoadingLastAccessed] = useState(true);
  const [copyingUserId, setCopyingUserId] = useState(null);
  const databaseRef = ref(firebaseDatabase, 'status_from_sns');
  const changeFieldFromFirebase = (draft_id, statusString) => {
    const dataToUpdate = {
      [draft_id]: {
        status: statusString,
      },
    };
    update(databaseRef, dataToUpdate);
  };
  const clearAllDummy = () => {
    dispatch(clearAllDummys());
  };
  const switchingFunction = async (obj) => {
    try {
      const formData = new FormData();
      formData.append('token', tokens);
      formData.append('user_id', obj.userId);
      formData.append('user_token', obj.token);
      const response = await axios.post(`${baseUrl}/managerUserLogs`, formData);
      if (response?.data?.success === true) {
        clearAllDummy();
        handleClick(obj);
        localStorage.setItem('firstname', obj?.firstname || '');
        localStorage.setItem('lastname', obj?.lastname || '');
        navigate('/dashboard');
        getSubscription();
        autoSignIn();
      } else {
        setmessaged(response?.data?.message);
        setmangerFunctionData(true);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error); // Handle any errors
    }
  };
  const uploadPercentages = useSelector((state) => state.upload);
  const managerTokenFunction = async (obj) => {
    const uploadingOrNot = Object.values(uploadPercentages).some(
      (value) => typeof value === 'number' || value === 'Starting Upload'
    );
    if (!uploadingOrNot) {
      clearAllDummy();
      switchingFunction(obj);
    } else {
      setmessaged('You are uploading, so not able to access');
      setInfoModal(true);
    }
  };

  // Silent refresh - fetches data without showing loader
  const silentRefreshData = async () => {
    try {
      const apiUrl = `${baseUrl}/managerUsersList`;
      const requestBody = {
        token: tokens,
      };
      const response = await axios.post(apiUrl, requestBody);
      setUserListData(response.data);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error fetching manager data:', error);
    }
  };

  const handleInviteUser = async (obj) => {
    // Optimistically update UI first - change icon to gray immediately
    setUserListData((prevData) => ({
      ...prevData,
      data: prevData.data.map((user) => (
        user.userId === obj.userId
          ? { ...user, signup_status: '2' }
          : user
      )),
    }));

    // Set inviting flag to prevent loader from showing
    setIsInviting(true);

    try {
      const response = await axios.post(`${baseUrl}/sendInviteLink`, {
        token: tokens,
        userId: obj.userId,
      });

      if (response?.data?.success) {
        setAppSnackbar({
          isVisible: true,
          message: response?.data?.message || 'Invitation sent successfully',
          type: 'success',
        });
        // Silently refresh data in background without showing loader
        await silentRefreshData();
      } else {
        // Revert the UI change if API failed
        setUserListData((prevData) => ({
          ...prevData,
          data: prevData.data.map((user) => (
            user.userId === obj.userId
              ? { ...user, signup_status: '0' }
              : user
          )),
        }));
        setAppSnackbar({
          isVisible: true,
          message: response?.data?.message || 'Failed to send invitation',
          type: 'error',
        });
      }
    } catch (error) {
      // Revert the UI change if API failed
      setUserListData((prevData) => ({
        ...prevData,
        data: prevData.data.map((user) => (
          user.userId === obj.userId
            ? { ...user, signup_status: '0' }
            : user
        )),
      }));
      // eslint-disable-next-line no-console
      console.error('Error inviting user:', error);
      setAppSnackbar({
        isVisible: true,
        message: error?.response?.data?.message || 'Failed to send invitation',
        type: 'error',
      });
    } finally {
      setIsInviting(false);
    }
  };
  // Fetch last 5 accessed users from new API
  const fetchLastAccessedUsers = async () => {
    setIsLoadingLastAccessed(true);
    try {
      const myToken = await getToken();
      const apiUrl = `${baseUrl}/${endpoints.lastAccessedUsers}`;
      const requestBody = {
        token: myToken,
        limit: 5,
      };
      const response = await axios.post(apiUrl, requestBody);
      if (response?.data?.success && response?.data?.data) {
        setLastAccessedUsers(response.data.data);
        onLastAccessedCountChange?.(response.data.data.length);
      } else {
        setLastAccessedUsers([]);
        onLastAccessedCountChange?.(0);
      }
    } catch (error) {
      console.error('Error fetching last accessed users:', error);
      setLastAccessedUsers([]);
      onLastAccessedCountChange?.(0);
    } finally {
      setIsLoadingLastAccessed(false);
    }
  };

  const handleCopySignupLink = async (obj) => {
    setCopyingUserId(obj.userId);
    try {
      const response = await axios.post(`${baseUrl}${endpoints.copySignupLink}`, {
        token: tokens,
        userId: obj.userId,
      });

      if (response?.data?.success && response?.data?.data?.short_url) {
        await navigator.clipboard.writeText(response.data.data.short_url);
        setAppSnackbar({
          isVisible: true,
          message: 'Signup link copied to clipboard',
          type: 'success',
        });
      } else {
        setAppSnackbar({
          isVisible: true,
          message: response?.data?.message || 'Failed to get signup link',
          type: 'error',
        });
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error copying signup link:', error);
      setAppSnackbar({
        isVisible: true,
        message: error?.response?.data?.message || 'Failed to copy signup link',
        type: 'error',
      });
    } finally {
      setCopyingUserId(null);
    }
  };
  useEffect(() => {
    fetchMangerData();
    fetchLastAccessedUsers();
  }, [isTokenChange]);

  useEffect(() => {
    const databaseRefManUsers = ref(firebaseDatabase, `manager_user_list_updates/${localStorage.getItem('id')}`);
    const dataCallbackMans = (snapshot) => {
      if (snapshot.exists()) {
        fetchMangerData();
        fetchLastAccessedUsers();
      }
    };
    onValue(databaseRefManUsers, dataCallbackMans);
    return () => {
      off(databaseRefManUsers, 'value', dataCallbackMans);
    };
  }, []);

  // Sync parent modal state with local modal state
  useEffect(() => {
    if (isOpenModal !== undefined) {
      setIsOpenAllUsersModal(isOpenModal);
    }
  }, [isOpenModal]);

  // Refresh data when modal opens to ensure all users (including hidden) are loaded
  // Call showAllUsers API to get complete list including hidden users (without showing toast or clearing hidden indices)
  useEffect(() => {
    if (isOpenAllUsersModal && showAll) {
      // Call showAll with both parameters false: no toast, don't clear hidden indices
      showAll(false, false);
    }
  }, [isOpenAllUsersModal]);
  const updateDummy = (dummy, status) => {
    if (status === 1) {
      dispatch(saveDummy({ [dummy?.draft_id]: dummy }));
    } else {
      dispatch(removeDummy(dummy));
    }
  };
  const handleUserData = (obj) => {
    // temp fix for production #TODO akash
    localStorage.setItem('temp_user_id', obj?.userId);
    // end temp fix
    setbigUserData(obj);
    navigate('/affiliate');
  };
  const closeToast = (draft_id, message, type) => {
    toast.update(draft_id, { closeButton: false, render: message, type: type === 'success' ? toast.TYPE.SUCCESS : toast.TYPE.ERROR, autoClose: 3000 });
    setUploadContainer((prevUploadContainer) => prevUploadContainer.filter((id) => id !== draft_id));
  };
  const updateUploadPercentages = (draft_id, data) => {
    dispatch(saveUploadInfo({ [draft_id]: data }));
  };
  const data = useSelector((state) => state.deleteUpload);
  const deleteAdded = (userObject) => {
    setOpen(false);
    setuserIamChanging(true);
    setEncounterLoading(true);
    const draftIds = Object.keys(uploadPercentages);
    const deletePromises = [];
    draftOfUpload.forEach((draftId) => {
      const uploadStatus = uploadPercentages[draftId];
      setActiveUploads([]);
      setUploadQueue([]);
      // Check if the uploadStatus is not "Please wait"
      if (uploadStatus !== 'Please wait') {
        // const deletePromise = axios
        //   .post(`${baseUrl}/deleteDraftContent`, {
        //     token: getToken(),
        //     draft_id: [draftId], // Pass the current draftId
        //     content_id: [],
        //   })
        //   .then((response) => {
        //     changeFieldFromFirebase(draftId, 'DELETED');
        //     updateDummy(draftId, 0);
        //     updateUploadPercentages(draftId, 'Cancelled');
        //     closeToast(draftId, 'Upload has been canceled by user', 'error');
        //     return response;
        //   })
        //   .catch((error) => {
        //     console.error(`Error deleting items for draftId ${draftId}:`, error);
        //     throw error;
        //   });
        // deletePromises.push(deletePromise);
        changeFieldFromFirebase(draftId, 'DELETED');
        updateDummy(draftId, 0);
        updateUploadPercentages(draftId, 'Cancelled');
        closeToast(draftId, 'Upload has been canceled by user', 'error');
        dispatch(clearUploadDetails());
      }
    });
    // Promise.all(deletePromises)
    //   .then(() => {
    //     setEncounterLoading(false);
    //     setInfoModal(false);
    //     setIamUploading(true);
    //     setuserIamChanging(false);
    //     switchingFunction(userObject);
    //   })
    //   .catch((error) => {
    //     console.error('Error deleting items:', error);
    //   });
    setEncounterLoading(false);
    setInfoModal(false);
    setIamUploading(true);
    setuserIamChanging(false);
    switchingFunction(userObject);
  };
  const CircularProgress = withStyles({
    circle: {
      color: '#5aa5ef !important'
    }
  })(MuiCircularProgress);

  const toggleHidden = (index) => {
    if (hiddenIndices.includes(index)) {
      setHiddenIndices(hiddenIndices.filter((i) => i !== index));
    } else {
      setHiddenIndices([...hiddenIndices, index]);
    }
  };
  const hideManagerUser = (userId, index) => {
    const updatedVisibleEye = [...visibleEye];
    updatedVisibleEye[index] = true;
    setVisibleEye(updatedVisibleEye);
    const API_URL = `${baseUrl}/hideManagerUser`;
    const data = {
      token: getToken(),
      user_id: userId
    };
    axios.post(API_URL, data)
      .then((response) => {
        toggleHidden(userId);
        setAppSnackbar({ isVisible: true, message: response?.data?.message, type: 'error' });
        setVisibleEye((prevVisibleEye) => {
          const updatedVisibleEye = [...prevVisibleEye];
          updatedVisibleEye[index] = false;
          return updatedVisibleEye;
        });
      })
      .catch((error) => {
        setAppSnackbar({ isVisible: true, type: 'error', message: error?.response?.message });
      });
  };

  // Function to re-hide users after modal closes (when showAll was called)
  const reHideUsers = () => {
    if (hiddenIndices && hiddenIndices.length > 0) {
      const API_URL = `${baseUrl}/hideManagerUser`;
      // Call hide API for each hidden user in parallel
      const hidePromises = hiddenIndices.map((userId) => axios.post(API_URL, {
        token: getToken(),
        user_id: userId
      }).catch(() => {
        // Silently handle errors for individual hide requests
      }));

      // After all hide requests complete, refresh data
      Promise.all(hidePromises).then(() => {
        if (fetchMangerData) {
          fetchMangerData();
        }
      });
    }
  };

  // Get ALL users including those that were hidden (for modal display)
  // We need to get all users from the original data before backend filtering
  const allUsersFromData = userListData?.data || [];

  // Get filtered users (excluding hidden ones) for outside modal display
  const visibleUsers = allUsersFromData.filter((obj) => !hiddenIndices.includes(obj?.userId));

  // Get latest 5 visible users in reverse order (last user becomes first)
  // const latest5Users = visibleUsers.slice(-5).reverse();
  // Use last accessed users from new API for the 5 users display (outside modal)
  const latest5Users = lastAccessedUsers;

  // For modal: Show ALL users from data (backend might have already filtered, but we show what we have)
  // Note: If backend removes hidden users, they won't appear here.
  // To truly show all, backend must return all users or we need to maintain full list separately
  const reversedAllUsers = [...allUsersFromData].reverse();

  // Export users to CSV
  const exportUsersToCSV = () => {
    if (!reversedAllUsers || reversedAllUsers.length === 0) {
      toast.error('No users to export');
      return;
    }

    const headers = ['Name', 'Email', 'Last Accessed'];
    const csvRows = [headers.join(',')];

    reversedAllUsers.forEach((user) => {
      const name = `${user?.firstname || ''} ${user?.lastname || ''}`.trim();
      const email = user?.email || '';
      const lastAccessed = user?.last_accessed
        ? new Date(user.last_accessed).toLocaleDateString('en-US', {
          month: 'short',
          day: 'numeric',
          year: 'numeric'
        })
        : '';

      // Escape fields that might contain commas or quotes
      const escapedName = `"${name.replace(/"/g, '""')}"`;
      const escapedEmail = `"${email.replace(/"/g, '""')}"`;
      const escapedDate = `"${lastAccessed}"`;

      csvRows.push([escapedName, escapedEmail, escapedDate].join(','));
    });

    const csvContent = csvRows.join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `users_list_${new Date().toISOString().split('T')[0]}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    toast.success('User list exported successfully');
  };

  // Render user row component
  const renderUserRow = (obj, index, isInModal = false) => (
    <div className={isInModal ? 'flexter w100' : 'flexter w100'} key={isInModal ? `modal-${obj?.userId}` : index} style={isInModal ? { marginBottom: '20px' } : {}}>
      <div className="rounder">{obj?.firstname?.charAt(0)?.toUpperCase()}</div>
      <div style={{ position: 'relative', flex: 1 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <p className="UserName">
            {obj?.firstname?.charAt(0)?.toUpperCase() + obj?.firstname?.slice(1)}
            {' '}
            {obj?.lastname?.charAt(0)?.toUpperCase() + obj?.lastname?.slice(1)}
          </p>
          {obj?.profile_status === 'Incomplete' && (
            <span style={{
              backgroundColor: '#FEE2E2',
              color: '#DC2626',
              fontSize: '11px',
              fontWeight: '700',
              padding: '3px 8px',
              borderRadius: '12px',
              border: '1.5px solid #EF4444',
              fontFamily: 'Montserrat',
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
              whiteSpace: 'nowrap'
            }}
            >
              Free Plan
            </span>
          )}
        </div>
        <p className="mySmallMail">
          {obj?.email}
        </p>
      </div>

      {/* Invite Button */}
      {obj?.signup_status === '0' && (

        <>
          <IconButton
            onClick={() => handleInviteUser(obj)}
            style={{ padding: '8px', color: '#5aa5ef' }}
            title="Send invitation"
          >
            <EmailIcon />
          </IconButton>
          <IconButton
            onClick={() => handleCopySignupLink(obj)}
            style={{ padding: '8px', color: '#5aa5ef' }}
            title="Copy signup link"
            disabled={copyingUserId === obj.userId}
          >
            {copyingUserId === obj.userId ? (
              <CircularProgress size={20} style={{ color: '#5aa5ef' }} />
            ) : (
              <FileCopyIcon style={{ fontSize: '20px' }} />
            )}
          </IconButton>
        </>
      )}
      {obj?.signup_status === '2' && (
        <>
          <IconButton
            onClick={() => handleInviteUser(obj)}
            style={{ padding: '8px', color: '#5aa5ef' }}
            title="Send invitation"
          >
            <EmailIcon />
          </IconButton>
          <IconButton
            onClick={() => handleCopySignupLink(obj)}
            style={{ padding: '8px', color: '#5aa5ef' }}
            title="Copy signup link"
            disabled={copyingUserId === obj.userId}
          >
            {copyingUserId === obj.userId ? (
              <CircularProgress size={20} style={{ color: '#5aa5ef' }} />
            ) : (
              <FileCopyIcon style={{ fontSize: '20px' }} />
            )}
          </IconButton>
        </>
      )}

      {/* Access Button */}
      <IconButton
        onClick={() => { setUserObject(obj); managerTokenFunction(obj); }}
        style={{ padding: '8px', color: '#5aa5ef' }}
        title="Access user account"
      >
        <ExitToAppIcon />
      </IconButton>

      {!isInModal && (
        <HiddenIcon onClick={() => hideManagerUser(obj?.userId, index)} className={visibleEye[index] ? 'visibleEye' : 'hiddenX'} />
      )}
    </div>
  );

  return (
    <div>
      {
        isOpenInfoModal && (
          <InfoModal
            isVisible={isOpenInfoModal}
            title="Uploading is in progress"
            onHide={() => { setInfoModal(false); }}
            continueButton="Continue with upload"
            userIamChanging={userIamChanging}
            actionButton="Access user anyway"
            action={() => deleteAdded(userObject)}
            isDelete
          />
        )
      }

      {/* All Users Modal */}
      <Dialog
        open={isOpenAllUsersModal}
        onClose={() => {
          setIsOpenAllUsersModal(false);
          if (setModal) setModal(false);
          reHideUsers();
        }}
        maxWidth="md"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: '12px',
            padding: '20px',
            maxHeight: '80vh',
            position: 'relative'
          }
        }}
      >
        {/* Close button - positioned absolutely at top right */}
        <button
          onClick={() => {
            setIsOpenAllUsersModal(false);
            if (setModal) setModal(false);
            reHideUsers();
          }}
          style={{
            position: 'absolute',
            top: '20px',
            right: '20px',
            background: '#f3f4f6',
            border: 'none',
            fontSize: '24px',
            cursor: 'pointer',
            color: '#6b7280',
            padding: '0.5rem',
            lineHeight: '1',
            borderRadius: '0.5rem',
            transition: 'all 0.2s ease',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1
          }}
          onMouseEnter={(e) => { e.target.style.background = '#e5e7eb'; }}
          onMouseLeave={(e) => { e.target.style.background = '#f3f4f6'; }}
        >
          ×
        </button>

        <DialogTitle style={{
          padding: '1.5rem 2rem',
          borderBottom: '1px solid #e5e7eb',
          background: '#f9fafb',
          margin: '-20px -20px 0 -20px'
        }}
        >
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            paddingRight: '40px'
          }}
          >
            <span style={{
              fontFamily: 'Montserrat, sans-serif',
              fontWeight: '700',
              fontSize: '1.5rem',
              color: '#111827',
              letterSpacing: '-0.02em'
            }}
            >
              View all users
            </span>
            <button
              onClick={exportUsersToCSV}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                padding: '8px 16px',
                backgroundColor: '#5aa5ef',
                color: '#ffffff',
                border: 'none',
                borderRadius: '8px',
                fontSize: '14px',
                fontWeight: '600',
                fontFamily: 'Montserrat, sans-serif',
                cursor: 'pointer',
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={(e) => { e.target.style.backgroundColor = '#4a95df'; }}
              onMouseLeave={(e) => { e.target.style.backgroundColor = '#5aa5ef'; }}
            >
              <GetAppIcon style={{ fontSize: '18px' }} />
              Export
            </button>
          </div>
        </DialogTitle>

        <DialogContent style={{ padding: '20px' }}>
          {/* Show All button - commented out as per requirement */}
          {/* {(hiddenIndices?.length > 0 || userListData?.show_all) && (
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '15px' }}>
              <button
                className="unhidePls"
                onClick={() => showAll && showAll()}
                disabled={clickLoading}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginLeft: 0,
                  marginTop: 0
                }}
              >
                {clickLoading ? <CircularProgress size={16} style={{ color: '#000000' }} /> : 'Show All'}
              </button>
            </div>
          )} */}

          {/* Table Header */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '14px 20px',
            borderBottom: '2px solid #e5e7eb',
            backgroundColor: '#f9fafb',
            fontFamily: 'Montserrat, sans-serif',
            fontWeight: '600',
            fontSize: '13px',
            color: '#374151',
            borderRadius: '8px 8px 0 0'
          }}
          >
            <span style={{ flex: 1, minWidth: '0' }}>Name</span>
            <span style={{ flex: 1, minWidth: '0' }}>Email</span>
            <span style={{ width: '100px', textAlign: 'left', marginRight: '10px' }}>Accessed on</span>
            <span style={{ width: '80px', minWidth: '120px', textAlign: 'right', paddingRight: '10px' }}>Actions</span>
          </div>

          {/* Table Body - Show ALL users including hidden ones */}
          <div style={{ maxHeight: '55vh', overflow: 'auto' }}>
            {reversedAllUsers.map((obj, index) => (
              <div
                key={obj?.userId}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '14px 20px',
                  borderBottom: '1px solid #f3f4f6',
                  transition: 'all 0.2s ease',
                  gap: '20px',
                  fontFamily: 'Montserrat, sans-serif'
                }}
                onMouseEnter={(e) => { e.currentTarget.style.background = '#f9fafb'; }}
                onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
              >
                {/* User Info */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '14px', flex: 1, minWidth: '0' }}>
                  <div style={{
                    width: '44px',
                    height: '44px',
                    borderRadius: '50%',
                    background: 'linear-gradient(135deg, #5aa5ef 0%, #4a95df 100%)',
                    color: '#ffffff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: '600',
                    fontSize: '16px',
                    flexShrink: '0',
                    boxShadow: '0 2px 6px rgba(90, 165, 239, 0.2)',
                    border: '2px solid #fff'
                  }}
                  >
                    {obj?.firstname?.charAt(0)?.toUpperCase()}
                  </div>
                  <div style={{ minWidth: '0', flex: '1' }}>
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px'
                    }}
                    >
                      <span style={{
                        fontWeight: '600',
                        color: '#1f2937',
                        fontSize: '14px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        lineHeight: '1.4',
                        letterSpacing: '-0.01em'
                      }}
                      >
                        {obj?.firstname?.charAt(0)?.toUpperCase() + obj?.firstname?.slice(1)}
                        {' '}
                        {obj?.lastname?.charAt(0)?.toUpperCase() + obj?.lastname?.slice(1)}
                      </span>
                      {obj?.profile_status === 'Incomplete' && (
                        <span style={{
                          backgroundColor: '#FEE2E2',
                          color: '#DC2626',
                          fontSize: '11px',
                          fontWeight: '700',
                          padding: '3px 8px',
                          borderRadius: '12px',
                          border: '1.5px solid #EF4444',
                          fontFamily: 'Montserrat',
                          textTransform: 'uppercase',
                          letterSpacing: '0.5px',
                          whiteSpace: 'nowrap'
                        }}
                        >
                          Free Plan
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                {/* Email */}
                <div style={{
                  color: '#6b7280',
                  fontSize: '13px',
                  flex: 1,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  fontWeight: '500',
                  minWidth: '0'
                }}
                >
                  {obj?.email}
                </div>

                {/* Accessed on */}
                <div style={{ width: '100px', textAlign: 'left', paddingLeft: '10px' }}>
                  {obj?.last_accessed && (
                    <span style={{
                      color: '#6b7280',
                      fontSize: '13px',
                      fontWeight: '500',
                      whiteSpace: 'nowrap'
                    }}
                    >
                      {new Date(obj.last_accessed).toLocaleDateString('en-US', {
                        month: 'short',
                        day: 'numeric',
                        year: 'numeric'
                      })}
                    </span>
                  )}
                </div>

                {/* Actions */}
                <div style={{ width: '120px', minWidth: '120px', display: 'flex', justifyContent: 'flex-end', gap: '4px', alignItems: 'center' }}>
                  {(obj?.signup_status === '0' || obj?.signup_status === '2') ? (
                    <>
                      <IconButton
                        onClick={() => handleInviteUser(obj)}
                        style={{ padding: '6px', color: '#5aa5ef' }}
                        title="Send invitation"
                      >
                        <EmailIcon style={{ fontSize: '20px' }} />
                      </IconButton>
                      <IconButton
                        onClick={() => handleCopySignupLink(obj)}
                        style={{ padding: '6px', color: '#5aa5ef' }}
                        title="Copy signup link"
                        disabled={copyingUserId === obj.userId}
                      >
                        {copyingUserId === obj.userId ? (
                          <CircularProgress size={18} style={{ color: '#5aa5ef' }} />
                        ) : (
                          <FileCopyIcon style={{ fontSize: '18px' }} />
                        )}
                      </IconButton>
                    </>
                  ) : (
                    <div style={{ width: '72px' }} />
                  )}
                  <IconButton
                    onClick={() => { setUserObject(obj); managerTokenFunction(obj); setIsOpenAllUsersModal(false); }}
                    style={{ padding: '6px', color: '#5aa5ef' }}
                    title="Access user account"
                  >
                    <ExitToAppIcon style={{ fontSize: '20px' }} />
                  </IconButton>
                  {/* Eye icon commented out as per requirement - no hide functionality in modal */}
                  {/* <HiddenIcon
                    onClick={() => hideManagerUser(obj?.userId, index)}
                    className={visibleEye[index] ? 'visibleEye' : 'hiddenX'}
                    style={{ cursor: 'pointer', width: '24px', height: '24px' }}
                    title="Hide user"
                  /> */}
                </div>
              </div>
            ))}
          </div>
        </DialogContent>
      </Dialog>

      <div className="the_Hieghter">
        {isLoadingLastAccessed && !isInviting ? (
          <div style={{ display: 'flex' }}>
            <CircularProgress />
          </div>
        ) : (
          <>
            {latest5Users.map((obj, i) => renderUserRow(obj, i, false))}
          </>
        )}
      </div>
    </div>

  );
}

export default ManagerList;
